import { render, staticRenderFns } from "./CompetitionReleaseTime.vue?vue&type=template&id=ac4801bc&scoped=true&"
import script from "./CompetitionReleaseTime.vue?vue&type=script&lang=js&"
export * from "./CompetitionReleaseTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4801bc",
  null
  
)

export default component.exports